import React from 'react'
import { createRoot } from 'react-dom/client'
import AppConfigLoader from './app.configLoader'
import AppConfigProvider from './components/AppConfigProvider/AppConfigProvider'

const container = document.getElementById('app')

if (!container) throw new Error('Cant find app container element')

const root = createRoot(container)
root.render(
  <AppConfigProvider>
    <AppConfigLoader />
  </AppConfigProvider>
)
